// Format a dish's price for display.
//
// The backend sends `item.price` as a range string like "A$17.0 - A$17.0" (or a real
// range "A$19.0 - A$28.0"). This collapses it to a single clean price when every size
// costs the same, and shows a range ONLY when the prices genuinely differ. Trailing
// zeros are trimmed (17.0 → 17, 18.50 → 18.5) but cents are preserved (18.5 stays 18.5).
export function formatDishPrice(item) {
  const raw = String(item && item.price != null ? item.price : "").trim();
  const nums = (raw.match(/[\d.]+/g) || []).map(parseFloat).filter((n) => !Number.isNaN(n));
  if (!nums.length) return raw;
  const clean = (n) => String(Math.round(n * 100) / 100);
  const uniq = [...new Set(nums)].sort((a, b) => a - b);
  if (uniq.length === 1) return `A$${clean(uniq[0])}`;
  return `A$${clean(uniq[0])} – A$${clean(uniq[uniq.length - 1])}`;
}
